// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-fallback {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 32px 16px;
  background: #ffffff;
}

.error-fallback-card {
  text-align: center;
  max-width: 760px;
  width: 100%;
}

.error-fallback-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.error-fallback-brand .logo-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.error-fallback-brand .popup-icon {
  width: 42px;
  height: 42px;
}

.error-fallback-brand .popup-logo {
  height: 32px;
}

.error-fallback-mark {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #2c68ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.error-fallback-mark img {
  width: 20px;
  height: 20px;
  display: block;
}

.error-fallback-name {
  font-family: "opensans", sans-serif;
  font-weight: 700;
  color: #2c68ad;
  letter-spacing: 1px;
  font-size: 18px;
}

.Error-image {
  height: 380px;
}

.error-fallback-title {
  font-family: "opensans", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #2c68ad;
  margin: 0 0 6px 0;
}

.error-fallback-message {
  font-family: "opensans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #8B8A8A;
  margin: 0 0 20px 0;
}

.error-fallback-illustration {
  display: flex;
  justify-content: center;
}

.error-fallback-illustration svg {
  width: 100%;
  max-width: 520px;
  height: auto;
}

.error-fallback-retry {
  margin-top: 18px;
  padding: 8px 20px;
  border-radius: 6px;
  background: #2c68ad;
  color: #ffffff;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.error-fallback-retry:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .error-fallback {
    min-height: calc(100vh - 120px);
  }
  .error-fallback-title {
    font-size: 20px;
  }
  .error-fallback-message {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/ErrorFallback/ErrorFallback.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAEF;;AACA;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAEF;;AACA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE;IACE,+BAAA;EAEF;EACA;IACE,eAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF","sourcesContent":[".error-fallback {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100%;\n  padding: 32px 16px;\n  background: #ffffff;\n}\n\n.error-fallback-card {\n  text-align: center;\n  max-width: 760px;\n  width: 100%;\n}\n\n.error-fallback-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.error-fallback-brand .logo-row {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.error-fallback-brand .popup-icon {\n  width: 42px;\n  height: 42px;\n}\n\n.error-fallback-brand .popup-logo {\n  height: 32px;\n}\n\n.error-fallback-mark {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: #2c68ad;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.error-fallback-mark img {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.error-fallback-name {\n  font-family: \"opensans\", sans-serif;\n  font-weight: 700;\n  color: #2c68ad;\n  letter-spacing: 1px;\n  font-size: 18px;\n}\n\n.Error-image{\n  height:380px;\n}\n.error-fallback-title {\n  font-family: \"opensans\", sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #2c68ad;\n  margin: 0 0 6px 0;\n}\n\n.error-fallback-message {\n  font-family: \"opensans\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #8B8A8A;\n  margin: 0 0 20px 0;\n}\n\n.error-fallback-illustration {\n  display: flex;\n  justify-content: center;\n}\n\n.error-fallback-illustration svg {\n  width: 100%;\n  max-width: 520px;\n  height: auto;\n}\n\n.error-fallback-retry {\n  margin-top: 18px;\n  padding: 8px 20px;\n  border-radius: 6px;\n  background: #2c68ad;\n  color: #ffffff;\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.error-fallback-retry:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .error-fallback {\n    min-height: calc(100vh - 120px);\n  }\n\n  .error-fallback-title {\n    font-size: 20px;\n  }\n\n  .error-fallback-message {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
